import ProductNutritionValuesTable from "./ProductNutritionValuesTable";

export default ProductNutritionValuesTable;